import { GraphOptionItemProps } from '../types'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

export const GraphOptionChoiceItem = <T,>({
	option,
	options,
	setOptionValue
}: GraphOptionItemProps<T>) => (
	<FormControl>
		<InputLabel id={`choice-${option.id}-label`}>
			{option.label}
		</InputLabel>
		<Select
			labelId={`choice-${option.id}-label`}
			label={option.label}
			id={`choice-${option.id}`}
			size="small"
			value={
				options.find((opt) => opt.id === option.id)?.value ??
				(option.nullable ? '**' : option.default ?? '**')
			}
			onChange={(event) =>
				setOptionValue(option.id, event.target.value)
			}
		>
			{ option.nullable && (
				<MenuItem key={`choice-empty`} value="**">
					なし
				</MenuItem>
			) }
			{ option.data?.map((data, i) => {
				return (
					<MenuItem key={`choice-${i}`} value={data.value}>
						{data.label}
					</MenuItem>
				)
			})}
		</Select>
	</FormControl>
)